import { Lightbox } from './Lightbox.js';

document.addEventListener('DOMContentLoaded', () => {
    new Lightbox();
});
